"use client";

const ChooseUs = () => {
  const openAccordion = (event: React.MouseEvent<HTMLDivElement>) => {
    document.querySelectorAll(".accordion-info").forEach((element) => {
      element.classList.remove("active");
      (element as HTMLElement).style.maxHeight = "0";
      if (element.parentElement) {
        element.parentElement.classList.remove("active");
      }
    });
    const parent = event.currentTarget.parentElement;
    const next = event.currentTarget.nextElementSibling as HTMLElement | null;
    if (parent) {
      parent.classList.add("active");
    }
    if (next) {
      next.style.maxHeight = "300px";
      next.classList.add("active");
    }
  };

  return (
    <section className="intro-accord">
      <div className="container ontop">
        <div className="row xlg-marg">
          <div className="col-lg-12 valign">
            <div>
              <div className="sec-head mb-50">
                <h6 className="sub-title main-color mb-15">Why choose us?</h6>
                <h3>Our process for building AI-powered digital solutions</h3>
              </div>
              <div className="accordion bord">
                <div className="item active wow fadeInUp" data-wow-delay=".1s">
                  <div onClick={openAccordion} className="title">
                    <h6>Designing Content With AI Power</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      We leverage the latest AI tools to create smart,
                      personalized, and engaging content. This helps your brand
                      communicate effectively and stay ahead in the digital
                      space.
                    </p>
                  </div>
                </div>
                <div className="item wow fadeInUp" data-wow-delay=".3s">
                  <div onClick={openAccordion} className="title">
                    <h6>Talented, Professional & Expert Team</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      Our team combines expertise in AI, cloud, and design to
                      deliver solutions that are both innovative and reliable.
                      We focus on turning your vision into real business impact.
                    </p>
                  </div>
                </div>
                <div className="item wow fadeInUp" data-wow-delay=".5s">
                  <div onClick={openAccordion} className="title">
                    <h6>We Build and Activate Brands</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      From strategy to launch, we craft digital experiences
                      powered by AI and cloud technologies. Our goal is to help
                      your brand connect, engage, and grow in today’s
                      competitive market.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChooseUs;
